/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DeviceDto } from '../models/DeviceDto';
import type { DeviceFilterDto } from '../models/DeviceFilterDto';
import type { DeviceNotificationDto } from '../models/DeviceNotificationDto';
import type { EntityModelResponseContainerDeviceDto } from '../models/EntityModelResponseContainerDeviceDto';
import type { PagedModelEntityModelDeviceDto } from '../models/PagedModelEntityModelDeviceDto';
import type { PagedModelEntityModelDeviceListEntryDto } from '../models/PagedModelEntityModelDeviceListEntryDto';
import type { PagedResourcesAssemblerDeviceDto } from '../models/PagedResourcesAssemblerDeviceDto';
import type { PagedResourcesAssemblerDeviceListEntryDto } from '../models/PagedResourcesAssemblerDeviceListEntryDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DeviceControllerService {
    /**
     * @returns PagedModelEntityModelDeviceListEntryDto OK
     * @throws ApiError
     */
    public static list({
        assembler,
        imeiEndsWith,
        filterKeys,
        filterValues,
        page,
        size = 20,
        sort,
    }: {
        assembler: PagedResourcesAssemblerDeviceListEntryDto,
        imeiEndsWith?: string,
        filterKeys?: Array<'IMEI' | 'DEVICE_GROUP_ID' | 'NETWORK_POLICY_ID' | 'ACTIVE_NETWORK_POLICY_ID' | 'STATE' | 'NETWORK_LOCK_STATE' | 'EXTERNAL_ID' | 'IMSI'>,
        filterValues?: Array<string>,
        /**
         * Zero-based page index (0..N)
         */
        page?: number,
        /**
         * The size of the page to be returned
         */
        size?: number,
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>,
    }): CancelablePromise<PagedModelEntityModelDeviceListEntryDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/program/devices',
            query: {
                'imeiEndsWith': imeiEndsWith,
                'filterKeys': filterKeys,
                'filterValues': filterValues,
                'page': page,
                'size': size,
                'sort': sort,
                'assembler': assembler,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerDeviceDto OK
     * @throws ApiError
     */
    public static create({
        requestBody,
    }: {
        requestBody: DeviceDto,
    }): CancelablePromise<EntityModelResponseContainerDeviceDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/program/devices',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static exportDevices({
        requestBody,
    }: {
        requestBody: DeviceFilterDto,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/program/devices-export',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static programExport({
        name,
        format = 'CSV',
    }: {
        name?: string,
        format?: 'CSV' | 'XLS',
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/program/devices-program-export',
            query: {
                'name': name,
                'format': format,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerDeviceDto OK
     * @throws ApiError
     */
    public static replaceDevice({
        imei,
        requestBody,
    }: {
        imei: string,
        requestBody: DeviceDto,
    }): CancelablePromise<EntityModelResponseContainerDeviceDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/admin/program/devices/by-imei/{imei}',
            path: {
                'imei': imei,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PagedModelEntityModelDeviceDto OK
     * @throws ApiError
     */
    public static filteredList({
        assembler,
        requestBody,
        page,
        size = 20,
        sort,
    }: {
        assembler: PagedResourcesAssemblerDeviceDto,
        requestBody: DeviceFilterDto,
        /**
         * Zero-based page index (0..N)
         */
        page?: number,
        /**
         * The size of the page to be returned
         */
        size?: number,
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>,
    }): CancelablePromise<PagedModelEntityModelDeviceDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/program/devices/filtered',
            query: {
                'page': page,
                'size': size,
                'sort': sort,
                'assembler': assembler,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static delete({
        deviceId,
    }: {
        deviceId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/admin/program/devices/{deviceId}',
            path: {
                'deviceId': deviceId,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerDeviceDto OK
     * @throws ApiError
     */
    public static read({
        deviceId,
    }: {
        deviceId: number,
    }): CancelablePromise<EntityModelResponseContainerDeviceDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/program/devices/{deviceId}',
            path: {
                'deviceId': deviceId,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerDeviceDto OK
     * @throws ApiError
     */
    public static update({
        deviceId,
        requestBody,
        xDeleteProperties,
        xOtpCode,
    }: {
        deviceId: number,
        requestBody: DeviceDto,
        xDeleteProperties?: Array<'IMEI' | 'DEVICE_GROUP_ID' | 'NETWORK_POLICY_ID' | 'ACTIVE_NETWORK_POLICY_ID' | 'STATE' | 'NETWORK_LOCK_STATE' | 'EXTERNAL_ID' | 'IMSI'>,
        xOtpCode?: string,
    }): CancelablePromise<EntityModelResponseContainerDeviceDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/admin/program/devices/{deviceId}',
            path: {
                'deviceId': deviceId,
            },
            headers: {
                'X-DELETE-PROPERTIES': xDeleteProperties,
                'X-OTP-CODE': xOtpCode,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static sendNotification({
        imei,
        requestBody,
    }: {
        imei: string,
        requestBody: DeviceNotificationDto,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/program/devices/{imei}/notifications',
            path: {
                'imei': imei,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
